<template>
 <v-container>
    <v-snackbar
        bottom right
        auto-height
        class="global-snackbar"
        :timeout="timeout"
        v-model="showSnackbar">
        {{description_text}}
        <v-btn v-if="button_text !== ''" text color="accent" @click="clickButton">{{ button_text }}</v-btn>
    </v-snackbar>
 </v-container>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    import {
        VUEX_SNACKBAR_SHOW,
        VUEX_SNACKBAR_CLICK_HIDE,
        VUEX_SNACKBAR_AUTO_HIDE,
    } from '@/store/constants/snackbar'

    export default {
        data () {
            return {

            }
        },
        created: function () {
            //special late arrival - open on create
            if (this.user.late_arrival_pending) {

                var id = this.user.late_arrival_pending ? this.user.late_arrival_pending.id : this.lateArrivalItemId
                var obj = {
                    lateArrivalId: id,
                    transition: 'confirm'
                }
                this.$store.dispatch(VUEX_SNACKBAR_SHOW, {
                    description_text: "Late Arrival - Pending Confirm",
                    button_text: "I'm here",
                    timeout: 0,
                    button_dispatch: "VUEX_CALENDAR_ITEM_UPDATE_LATE_ARRIVAL",
                    button_dispatch_payload: obj,
                })
            }
        },
        computed: {
            ...mapState({
                show: state => state.snackbar.show,

                button_text: state => state.snackbar.button_text,
                description_text: state => state.snackbar.description_text,
                timeout: state => state.snackbar.timeout,

                user: state => state.auth.currentUser,
                lateArrivalItemId: state => state.calendarItems.lateArrivalItemId,
            }),
            showSnackbar: {
                get:function() { return this.show },
                set:function(data) {
                    this.$store.dispatch(VUEX_SNACKBAR_AUTO_HIDE)
                },
            },
        },
        methods: {
            ...mapActions({
                clickButton : VUEX_SNACKBAR_CLICK_HIDE,
            }),

        }
    }
</script>